import { memo } from 'react';
import type { CanvasGroup, GroupBounds } from '../../types';
import { CanvasGroupBoxCollapsed } from './GroupBoxCollapsed';
import { CanvasGroupBoxExpanded } from './GroupBoxExpanded';

export interface CanvasGroupBoxProps {
  group: CanvasGroup;
  bounds: GroupBounds;
}

function CanvasGroupBoxInner({ group, bounds }: CanvasGroupBoxProps) {
  if (group.collapsed) {
    return <CanvasGroupBoxCollapsed group={group} bounds={bounds} />;
  }
  return <CanvasGroupBoxExpanded group={group} bounds={bounds} />;
}

export const CanvasGroupBox = memo(CanvasGroupBoxInner);
